/**
 * Aug 2026 — iOS Safari compatibility shims. MUST be the first import in
 * index.js: dependencies in the production bundle call Object.hasOwn
 * (unsupported on iOS < 15.4), which white-screened the Field App on
 * older iPhones (e.g. /field/inspection/{id} blank while desktop worked).
 * CRA transpiles syntax but never polyfills runtime APIs — these fill
 * exactly the gaps found in the built bundle plus the usual suspects.
 */
/* eslint-disable no-extend-native */
if (typeof Object.hasOwn !== "function") {
  Object.defineProperty(Object, "hasOwn", {
    value: (obj, prop) => Object.prototype.hasOwnProperty.call(Object(obj), prop),
    writable: true, configurable: true,
  });
}
if (typeof Array.prototype.at !== "function") {
  Object.defineProperty(Array.prototype, "at", {
    value: function at(n) {
      n = Math.trunc(n) || 0;
      if (n < 0) n += this.length;
      return n < 0 || n >= this.length ? undefined : this[n];
    },
    writable: true, configurable: true,
  });
}
if (typeof String.prototype.at !== "function") {
  Object.defineProperty(String.prototype, "at", {
    value: function at(n) {
      n = Math.trunc(n) || 0;
      if (n < 0) n += this.length;
      return n < 0 || n >= this.length ? undefined : this[n];
    },
    writable: true, configurable: true,
  });
}
if (typeof structuredClone !== "function") {
  window.structuredClone = (v) => JSON.parse(JSON.stringify(v));
}
if (typeof crypto !== "undefined" && typeof crypto.randomUUID !== "function") {
  try {
    crypto.randomUUID = () =>
      "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
  } catch {
    /* crypto may be read-only in exotic webviews — randomUUID callers are guarded */
  }
}

// LAST-RESORT visible error screen: if the app still dies before React
// mounts (future unsupported API, chunk load failure), show WHAT broke
// instead of a silent white page so users can report it.
window.addEventListener("error", (event) => {
  try {
    const root = document.getElementById("root");
    if (!root || root.childElementCount > 0) return;   // app already rendered
    if (!event?.error && !event?.message) return;
    root.innerHTML =
      '<div style="font-family:sans-serif;padding:24px;max-width:560px;margin:40px auto;border:1px solid #fca5a5;border-radius:16px;background:#fef2f2;color:#7f1d1d">' +
      "<h2 style='margin:0 0 8px;font-size:18px'>Something went wrong loading this page</h2>" +
      "<p style='font-size:14px'>Please update your device to the latest iOS/browser version and reload. If it keeps happening, send us this message:</p>" +
      `<pre style="white-space:pre-wrap;font-size:11px;background:#fff;padding:10px;border-radius:8px">${String(event.message || event.error).slice(0, 400)}</pre></div>`;
  } catch { /* never make things worse */ }
});
